import palette from '../palette';

const MuiFormControlLabel = {
  label: {
    color: palette.text.placeholder,
  },
};

export default MuiFormControlLabel;
